<script lang="ts" setup>
	const {
		perPage = 30,
		step = 30,
		totalCount,
		...props
	} = defineProps<{
		perPage?: number
		totalCount?: number
		totalPages?: number
		step?: number
	}>()

	const defaultMax = 100

	const maxLimit =
		totalCount && totalCount > 0 ? totalCount : props.totalPages ? props.totalPages * perPage : defaultMax
	const limitList = ref(
		Array.from({ length: Math.ceil(maxLimit / step) }, (_, i) => {
			const value = (i + 1) * step
			return {
				value,
				label: `${value} / pages`
			}
		}).filter(option => option.value <= maxLimit)
	)

	const modelValue = defineModel<number>({ default: 30 })

	watch(
		() => perPage,
		() => {
			modelValue.value = perPage
		},
		{ immediate: true }
	)
</script>

<template>
	<div>
		<ui-select
			v-model="modelValue"
			:options="limitList"
			class="min-w-[100px]"
			trigger-class="p-2 !rounded-md text-xs"
		/>
	</div>
</template>
